exports.NAVIGATION = {
    'baseURL': '/images/Nav/',
    'logo': 'logo.png',
}